import agent_attorney_uischema from "./agent_attorney_uischema";
import agent_attorey_individs_uischema from "./agent_attorney_individs_uischema";
import employer_uischema from "./employer_uischema";
import employer_pocs_uischema from "./employer_pocs_uischema";
import foreign_labor_uischema from "./foreign_labor_uischema";
import crop_uischema from "./crop_uischema";
import agriculture_uischema from "./agriculture_uischema";
import worker_housing_uischema from "./worker_housing_uischema";
import material_terms_uischema from "./material_terms_uischema";
import foreign_worker_uischema from "./foreign_worker_uischema";
import foreign_worker_group_schema from "./foreign_worker_group";


const ProfileUISchemaResolver = (tableName) => {
  const profileUISchemaList = {
    "agent-attorney": agent_attorney_uischema,
    "agent-attorney-individs": agent_attorey_individs_uischema,
    employer: employer_uischema,
    "employer-pocs": employer_pocs_uischema,
    "foreign-labor": foreign_labor_uischema,
    crop: crop_uischema,
    agriculture: agriculture_uischema,
    "worker-housing": worker_housing_uischema,
    "material-terms": material_terms_uischema,
    "foreign-worker": foreign_worker_uischema,
    "foreign-worker-group": foreign_worker_group_schema,
  };
  return profileUISchemaList[tableName] || agent_attorney_uischema;
};

export default ProfileUISchemaResolver;
